import { Theme } from "@mui/material";

export enum EDeviceType {
    SMALL_MOBILE = "SMALL_MOBILE",
    MOBILE = "MOBILE",
    MOBILE_OR_TABLET = "MOBILE_OR_TABLET",
    TABLET = "TABLET",
    TABLET_OR_DESKTOP = "TABLET_OR_DESKTOP",
    DESKTOP = "DESKTOP",
    LARGE_DESKTOP = "LARGE_DESKTOP",
}

const breakpointMap: Record<EDeviceType, (theme: Theme) => string> = {
    [EDeviceType.SMALL_MOBILE]: (theme: Theme) => theme.breakpoints.down("sm"),
    [EDeviceType.MOBILE]: (theme: Theme) => theme.breakpoints.down("md"),
    [EDeviceType.MOBILE_OR_TABLET]: (theme: Theme) => theme.breakpoints.down("lg"),
    [EDeviceType.TABLET]: (theme: Theme) => theme.breakpoints.between("md", "lg"),
    [EDeviceType.TABLET_OR_DESKTOP]: (theme: Theme) => theme.breakpoints.up("md"),
    [EDeviceType.DESKTOP]: (theme: Theme) => theme.breakpoints.up("lg"),
    [EDeviceType.LARGE_DESKTOP]: (theme: Theme) => theme.breakpoints.up("xl"),
};

export const getThemeBreakpointByDeviceType = (theme: Theme, deviceType: EDeviceType) =>
    breakpointMap[deviceType]?.(theme) ?? breakpointMap[EDeviceType.DESKTOP](theme);
